/* coss-bundle.js — Bundle picker. Self-contained IIFE, no external deps. */
(function () {
  'use strict';

  var el = document.getElementById('coss-bundle');
  if (!el) return;

  var BUNDLE_SIZE   = parseInt(el.dataset.bundleSize, 10) || 2;
  var DISCOUNT_PCT  = parseInt(el.dataset.discountPct, 10) || 5;

  /* ── State ────────────────────────────────────────────────────────────── */
  var bundle = [];        // [{ productId, variantId, title, price, image, opt1, opt2 }, ...]
  var pendingCard    = null;
  var pendingVars    = null;
  var selectedOpt1   = null;
  var selectedOpt2   = null;
  var pendingNewItem = null; // staged item waiting for replace confirm

  /* ── DOM refs ─────────────────────────────────────────────────────────── */
  var modal        = document.getElementById('coss-bundle-modal');
  var mOverlay     = document.getElementById('coss-bundle-overlay');
  var mClose       = document.getElementById('coss-bundle-modal-close');
  var mImg         = document.getElementById('coss-bundle-modal-img');
  var mTitle       = document.getElementById('coss-bundle-modal-title');
  var mPrice       = document.getElementById('coss-bundle-modal-price');
  var mConfirm     = document.getElementById('coss-bundle-modal-confirm');
  var opt1Group    = document.getElementById('coss-bundle-opt1-group');
  var opt1NameEl   = document.getElementById('coss-bundle-opt1-name');
  var opt1ValEl    = document.getElementById('coss-bundle-opt1-val');
  var opt1List     = document.getElementById('coss-bundle-opt1-list');
  var opt2Group    = document.getElementById('coss-bundle-opt2-group');
  var opt2NameEl   = document.getElementById('coss-bundle-opt2-name');
  var opt2ValEl    = document.getElementById('coss-bundle-opt2-val');
  var opt2List     = document.getElementById('coss-bundle-opt2-list');
  var replaceDialog  = document.getElementById('coss-bundle-replace');
  var replaceOverlay = document.getElementById('coss-bundle-replace-overlay');
  var replaceItems   = document.getElementById('coss-bundle-replace-items');
  var replaceCancel  = document.getElementById('coss-bundle-replace-cancel');
  var bar            = document.getElementById('coss-bundle-bar');
  var barCount       = document.getElementById('coss-bundle-bar-count');
  var barPriceEl     = document.getElementById('cb-price-display');
  var barSlots       = document.getElementById('coss-bundle-slots');
  var barCta         = document.getElementById('coss-bundle-cta');
  var topCount       = document.getElementById('coss-bundle-topbar-count');
  var grid           = document.getElementById('coss-bundle-grid');
  var toastEl        = null;

  /* ── Helpers ──────────────────────────────────────────────────────────── */

  function money(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'coss-bundle-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('coss-bundle-toast--show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('coss-bundle-toast--show'); }, 2400);
  }

  function parseVariants(card) {
    try { return JSON.parse(card.dataset.variants); } catch (e) { return []; }
  }

  /* ── Helpers ──────────────────────────────────────────────────────────── */

  function calcTotal() {
    if (!bundle.length) return null;
    var totalCents = bundle.reduce(function (s, item) { return s + (item.price || 0); }, 0);
    var discCents  = Math.round(totalCents * (1 - DISCOUNT_PCT / 100));
    var saveCents  = totalCents - discCents;
    return { original: money(totalCents), discounted: money(discCents), saved: money(saveCents), pct: DISCOUNT_PCT };
  }

  /* ── Bar / UI updates ─────────────────────────────────────────────────── */

  function updateBar() {
    var n = bundle.length;
    var full = n >= BUNDLE_SIZE;
    var countLabel = n + ' of ' + BUNDLE_SIZE + ' selected';
    if (topCount) topCount.textContent = countLabel;

    /* Named slots */
    if (barSlots) {
      var slots = barSlots.querySelectorAll('.cb-slot');
      slots.forEach(function (slot, i) {
        var item = bundle[i];
        if (item) {
          slot.classList.add('cb-slot--filled');
          var opts = [item.opt1, item.opt2].filter(function (o) { return o && o !== 'Default Title'; }).join(' / ');
          slot.innerHTML =
            '<div class="cb-slot__filled-inner">' +
              (item.image ? '<img class="cb-slot__img" src="' + item.image + '" alt="" loading="lazy">' : '<div class="cb-slot__img"></div>') +
              '<div class="cb-slot__info">' +
                '<div class="cb-slot__name">' + esc(item.title) + '</div>' +
                (opts ? '<div class="cb-slot__opts">' + esc(opts) + '</div>' : '') +
              '</div>' +
              '<button class="cb-slot__remove" data-idx="' + i + '" type="button" aria-label="Remove">&#215;</button>' +
            '</div>';
          slot.querySelector('.cb-slot__remove').addEventListener('click', function (e) {
            e.stopPropagation();
            removeItem(parseInt(this.dataset.idx, 10));
          });
        } else {
          slot.classList.remove('cb-slot--filled');
          slot.innerHTML = '<div class="cb-slot__empty"><span class="cb-slot__plus" aria-hidden="true">+</span><span class="cb-slot__lbl">Add item ' + (i + 1) + '</span></div>';
        }
      });
    }

    /* Price total */
    if (barCount) {
      barCount.style.display = full ? 'none' : '';
      if (!full) barCount.textContent = countLabel;
    }
    if (barPriceEl) {
      barPriceEl.style.display = full ? 'flex' : 'none';
      if (full) {
        var t = calcTotal();
        barPriceEl.innerHTML = t
          ? '<div class="cb-price-row"><span class="cb-price-original">' + t.original + '</span><span class="cb-price-final">' + t.discounted + '</span></div><span class="cb-price-save">Save ' + t.saved + ' (' + t.pct + '% off)</span>'
          : '';
      }
    }

    /* Show bar when at least 1 item selected */
    bar.classList.toggle('coss-bundle-bar--visible', n > 0);

    /* CTA state */
    barCta.disabled = !full;
    barCta.setAttribute('aria-disabled', String(!full));
    barCta.textContent = full
      ? 'Add ' + BUNDLE_SIZE + ' to Cart →'
      : 'Add ' + BUNDLE_SIZE + ' to Cart (' + n + '/' + BUNDLE_SIZE + ')';
  }

  function countInBundle(productId) {
    return bundle.filter(function (b) { return b.productId === productId; }).length;
  }

  /* Same product can be added more than once (stacking same-item qty).
     Card shows how many are in, and the top-right badge doubles as a
     "remove one" button once count > 0.                                */
  function markCard(productId) {
    var count = countInBundle(productId);
    document.querySelectorAll('.coss-bundle-card[data-product-id="' + productId + '"]').forEach(function (c) {
      c.classList.toggle('coss-bundle-card--selected', count > 0);
      var btn = c.querySelector('.coss-bundle-card__btn');
      if (btn) {
        var isMulti = c.dataset.isMulti === 'true';
        btn.textContent = count > 0
          ? (isMulti ? 'Add Another (' + count + ')' : '+ Add to Bundle (' + count + ')')
          : (isMulti ? 'Select Variant' : '+ Add to Bundle');
      }
    });
  }

  /* ── Bundle mutations ─────────────────────────────────────────────────── */

  function addItem(item) {
    bundle.push(item);
    markCard(item.productId);
    updateBar();
    toast('Added! ' + bundle.length + '/' + BUNDLE_SIZE + ' selected');
  }

  function removeItem(idx) {
    var item = bundle[idx];
    if (!item) return;
    bundle.splice(idx, 1);
    markCard(item.productId);
    updateBar();
  }

  function replaceItem(idx, newItem) {
    var old = bundle[idx];
    bundle[idx] = newItem;
    markCard(old.productId);
    markCard(newItem.productId);
    updateBar();
    toast('Replaced in bundle');
  }

  /* ── Variant modal ────────────────────────────────────────────────────── */

  function openModal(card) {
    pendingCard  = card;
    selectedOpt1 = null;
    selectedOpt2 = null;
    pendingVars  = parseVariants(card);

    var isMulti   = card.dataset.isMulti === 'true';
    var opt1Name  = card.dataset.opt1;
    var opt2Name  = card.dataset.opt2;

    if (mTitle) mTitle.textContent = card.dataset.productTitle;
    if (mPrice) mPrice.textContent = money(parseInt(card.dataset.price, 10) || 0);
    if (mImg)   { mImg.src = card.dataset.img || ''; mImg.alt = card.dataset.productTitle; }
    setConfirmState(false);

    if (!isMulti) {
      /* Single variant — no options needed */
      if (opt1Group) opt1Group.style.display = 'none';
      if (opt2Group) opt2Group.style.display = 'none';
      setConfirmState(true);
    } else {
      /* Multi-variant: build opt1 (colour swatches) */
      if (opt1NameEl) opt1NameEl.textContent = opt1Name || 'Colour';
      if (opt1ValEl)  opt1ValEl.textContent = 'Select';
      buildOpt1(opt1Name);
      if (opt1Group)  opt1Group.style.display = '';

      /* opt2 (size) */
      if (opt2Name) {
        if (opt2NameEl) opt2NameEl.textContent = opt2Name || 'Size';
        if (opt2ValEl)  opt2ValEl.textContent = 'Select';
        if (opt2List)   opt2List.innerHTML = '';
        if (opt2Group)  opt2Group.style.display = '';
        buildOpt2(null);
      } else {
        if (opt2Group) opt2Group.style.display = 'none';
      }
    }

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (mClose) mClose.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    pendingCard = null;
    pendingVars = null;
  }

  function buildOpt1(opt1Name) {
    if (!opt1List) return;
    opt1List.innerHTML = '';
    var isColorOpt = /colou?r|shade|finish/i.test(opt1Name || '');
    var seen = [];
    pendingVars.forEach(function (v) {
      if (!v.opt1 || seen.includes(v.opt1)) return;
      seen.push(v.opt1);
      var hasSwatch = isColorOpt && (v.color || v.img);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.opt1 = v.opt1;
      btn.title = v.opt1;

      if (hasSwatch) {
        btn.className = 'cb-swatch-btn';
        if (v.color) btn.style.background = v.color;
        else if (v.img) { btn.style.backgroundImage = 'url(' + v.img + ')'; btn.style.backgroundSize = 'cover'; }
      } else {
        btn.className = 'cb-opt-btn';
        btn.textContent = v.opt1;
      }

      var anyAvail = pendingVars.some(function (pv) { return pv.opt1 === v.opt1 && pv.available; });
      if (!anyAvail) {
        btn.classList.add(hasSwatch ? 'cb-swatch-btn--oos' : 'cb-opt-btn--oos');
        btn.disabled = true;
      } else {
        btn.addEventListener('click', function () { onOpt1Click(v.opt1, this); });
      }
      opt1List.appendChild(btn);
    });
  }

  function buildOpt2(filterOpt1) {
    if (!opt2List) return;
    opt2List.innerHTML = '';
    var seen = [];
    pendingVars.forEach(function (v) {
      if (filterOpt1 && v.opt1 !== filterOpt1) return;
      if (!v.opt2 || seen.includes(v.opt2)) return;
      seen.push(v.opt2);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cb-opt-btn';
      btn.textContent = v.opt2;
      btn.dataset.opt2 = v.opt2;
      if (!v.available) {
        btn.classList.add('cb-opt-btn--oos');
        btn.disabled = true;
      } else {
        btn.addEventListener('click', function () { onOpt2Click(v.opt2, this); });
      }
      opt2List.appendChild(btn);
    });
  }

  function onOpt1Click(val, btnEl) {
    selectedOpt1 = val;
    selectedOpt2 = null;
    if (opt1ValEl) opt1ValEl.textContent = val;
    if (opt2ValEl) opt2ValEl.textContent = 'Select';
    /* Deactivate siblings */
    opt1List.querySelectorAll('[data-opt1]').forEach(function (b) {
      b.classList.remove('cb-swatch-btn--active', 'cb-opt-btn--active');
    });
    btnEl.classList.add(btnEl.classList.contains('cb-swatch-btn') ? 'cb-swatch-btn--active' : 'cb-opt-btn--active');
    /* Update image/price for first matching variant */
    var ref = pendingVars.find(function (v) { return v.opt1 === val; });
    if (ref) {
      if (ref.image && mImg) mImg.src = ref.image;
      if (mPrice) mPrice.textContent = money(ref.price);
    }
    buildOpt2(val);
    /* If no opt2 needed */
    if (!opt2Group || opt2Group.style.display === 'none') setConfirmState(true);
    else setConfirmState(false);
  }

  function onOpt2Click(val, btnEl) {
    selectedOpt2 = val;
    if (opt2ValEl) opt2ValEl.textContent = val;
    opt2List.querySelectorAll('[data-opt2]').forEach(function (b) { b.classList.remove('cb-opt-btn--active'); });
    btnEl.classList.add('cb-opt-btn--active');
    var ref = pendingVars.find(function (v) { return v.opt1 === selectedOpt1 && v.opt2 === val; });
    if (ref && mPrice) mPrice.textContent = money(ref.price);
    setConfirmState(true);
  }

  function setConfirmState(ready) {
    if (!mConfirm) return;
    mConfirm.disabled = !ready;
    mConfirm.textContent = ready ? 'Add to Bundle' : 'Select Variant';
  }

  function onConfirm() {
    if (!pendingCard || !pendingVars) return;
    var matched = pendingVars.find(function (v) {
      var o1 = !selectedOpt1 || v.opt1 === selectedOpt1;
      var o2 = !selectedOpt2 || v.opt2 === selectedOpt2;
      return o1 && o2;
    }) || pendingVars[0];

    var newItem = {
      productId: pendingCard.dataset.productId,
      variantId: (matched && matched.id) || parseInt(pendingCard.dataset.variantId, 10),
      title:     pendingCard.dataset.productTitle,
      price:     (matched && matched.price) || parseInt(pendingCard.dataset.price, 10) || 0,
      image:     (matched && matched.image) || pendingCard.dataset.img || '',
      opt1:      selectedOpt1 || (matched && matched.opt1) || '',
      opt2:      selectedOpt2 || (matched && matched.opt2) || ''
    };

    closeModal();

    if (bundle.length >= BUNDLE_SIZE) {
      pendingNewItem = newItem;
      openReplace();
    } else {
      addItem(newItem);
    }
  }

  /* ── Replace dialog ───────────────────────────────────────────────────── */

  function openReplace() {
    if (!replaceDialog || !replaceItems) return;
    replaceItems.innerHTML = '';
    bundle.forEach(function (item, idx) {
      var btn = document.createElement('button');
      btn.className = 'cb-replace-item';
      btn.type = 'button';
      btn.innerHTML =
        (item.image
          ? '<img class="cb-replace-item__img" src="' + item.image + '" alt="' + esc(item.title) + '">'
          : '<div class="cb-replace-item__img"></div>') +
        '<div class="cb-replace-item__info">' +
          '<div class="cb-replace-item__name">' + esc(item.title) + '</div>' +
          '<div class="cb-replace-item__opts">' + esc([item.opt1, item.opt2].filter(Boolean).join(' / ')) + '</div>' +
        '</div>';
      btn.addEventListener('click', function () {
        replaceItem(idx, pendingNewItem);
        closeReplace();
      });
      replaceItems.appendChild(btn);
    });
    replaceDialog.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeReplace() {
    if (replaceDialog) replaceDialog.hidden = true;
    document.body.style.overflow = '';
    pendingNewItem = null;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  /* ── Add all to cart ──────────────────────────────────────────────────── */

  function addAllToCart() {
    if (bundle.length < BUNDLE_SIZE) return;
    barCta.disabled = true;
    barCta.textContent = 'Adding…';

    var items = bundle.map(function (b) { return { id: parseInt(b.variantId, 10), quantity: 1 }; });

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) {
        var msg = e.description || e.message || ('Error ' + r.status);
        console.error('[coss-bundle] cart error ' + r.status + ':', msg, 'items:', items);
        throw new Error(msg);
      });
      return r.json();
    })
    .then(function () {
      /* Clear bundle state */
      var prev = bundle.slice();
      bundle = [];
      prev.forEach(function (item) { markCard(item.productId); });
      updateBar();

      /* Open mini-cart (XO theme) */
      openMiniCart();
    })
    .catch(function (err) {
      console.error('[coss-bundle] add to cart error:', err);
      barCta.disabled = false;
      barCta.textContent = err.message && err.message.length < 80 ? err.message : 'Error — try again';
    });
  }

  function openMiniCart() {
    /* Try multiple selectors — XO cart trigger varies by theme version */
    var trigger =
      document.querySelector('[xo-trigger="cart"]') ||
      document.querySelector('[data-cart-trigger]') ||
      document.querySelector('.cs-cart-badge') ||
      document.querySelector('.xo-cart-trigger') ||
      document.querySelector('xo-cart-count') ||
      document.querySelector('a[href="/cart"]');
    if (trigger) { trigger.click(); return; }
    /* Dispatch events as fallback */
    ['xo:open:cart', 'cart:open', 'theme:cart:open'].forEach(function (n) {
      window.dispatchEvent(new CustomEvent(n));
    });
  }

  /* ── Card click handler (delegated) ───────────────────────────────────── */

  if (grid) {
    grid.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cs-bundle-remove]');
      if (removeBtn) {
        var rCard = removeBtn.closest('.coss-bundle-card');
        if (!rCard) return;
        var pid = rCard.dataset.productId;
        /* Remove the most-recently-added unit of this product (LIFO) */
        for (var i = bundle.length - 1; i >= 0; i--) {
          if (bundle[i].productId === pid) { removeItem(i); break; }
        }
        return;
      }

      var btn = e.target.closest('[data-cs-bundle-add]');
      if (!btn) return;
      var card = btn.closest('.coss-bundle-card');
      if (!card) return;

      var isMulti = card.dataset.isMulti === 'true';
      if (isMulti) {
        openModal(card);
      } else {
        /* Single variant — build item directly */
        var vars = parseVariants(card);
        var v = vars[0] || {};
        var singleItem = {
          productId: card.dataset.productId,
          variantId: v.id || parseInt(card.dataset.variantId, 10),
          title:     card.dataset.productTitle,
          price:     v.price || parseInt(card.dataset.price, 10) || 0,
          image:     v.image || card.dataset.img || '',
          opt1:      v.opt1 || '',
          opt2:      v.opt2 || ''
        };
        if (bundle.length >= BUNDLE_SIZE) {
          pendingNewItem = singleItem;
          openReplace();
        } else {
          addItem(singleItem);
        }
      }
    });
  }

  /* ── Event wiring ─────────────────────────────────────────────────────── */

  if (mClose)   mClose.addEventListener('click', closeModal);
  if (mOverlay) mOverlay.addEventListener('click', closeModal);
  if (mConfirm) mConfirm.addEventListener('click', onConfirm);

  if (replaceOverlay) replaceOverlay.addEventListener('click', closeReplace);
  if (replaceCancel)  replaceCancel.addEventListener('click', closeReplace);

  if (barCta) barCta.addEventListener('click', addAllToCart);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (modal && !modal.hidden) { closeModal(); return; }
    if (replaceDialog && !replaceDialog.hidden) closeReplace();
  });

  /* ── Category filter + search (combined — a card shows only if it
     matches both the active tab and the current search text) ─────────── */

  var searchInput = document.getElementById('cb-product-search');

  function getActiveCat() {
    var filterBar = document.querySelector('.cb-filter-bar');
    var activeBtn = filterBar ? filterBar.querySelector('.cb-filter-btn--active') : null;
    return activeBtn ? activeBtn.dataset.cat : 'all';
  }

  function applyFilters(cards) {
    var cat = getActiveCat();
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
    cards.forEach(function (card) {
      var cats = card.dataset.cats ? card.dataset.cats.split(' ') : [];
      var matchesCat = cat === 'all' || cats.indexOf(cat) !== -1;
      var title = (card.dataset.productTitle || '').toLowerCase();
      var matchesSearch = !query || title.indexOf(query) !== -1;
      card.style.display = (matchesCat && matchesSearch) ? '' : 'none';
    });
  }

  (function initFilter() {
    var filterBar = document.querySelector('.cb-filter-bar');
    if (!filterBar || !grid) return;
    filterBar.addEventListener('click', function (e) {
      var btn = e.target.closest('.cb-filter-btn');
      if (!btn) return;
      filterBar.querySelectorAll('.cb-filter-btn').forEach(function (b) {
        b.classList.toggle('cb-filter-btn--active', b === btn);
        b.setAttribute('aria-selected', String(b === btn));
      });
      applyFilters(grid.querySelectorAll('.coss-bundle-card'));
    });
  }());

  /* loadAllRemaining is reassigned inside initLoadMore below (if there's
     anything left to load); search calls it so results are always
     complete instead of just whatever's on the first page.            */
  var loadAllRemaining = function () { return Promise.resolve(); };

  (function initSearch() {
    if (!searchInput || !grid) return;
    var clearBtn = document.getElementById('cb-search-clear');
    var loaded = false;

    function run() {
      if (clearBtn) clearBtn.hidden = searchInput.value.trim() === '';
      applyFilters(grid.querySelectorAll('.coss-bundle-card'));
    }

    searchInput.addEventListener('input', function () {
      run();
      if (!loaded) {
        loaded = true;
        loadAllRemaining().then(run);
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        searchInput.value = '';
        run();
        searchInput.focus();
      });
    }
  }());

  /* ── Load more + background count sync ────────────────────────────────
     Shopify caps `paginate by` at 250, so >250 products need real page
     fetches, not a bigger `paginate by`. Cards render lazily (only on
     click), but tab counts would stay wrong until everything's loaded —
     so a lightweight background walk fetches every remaining page just
     for its tags (cards cached, not inserted) and fixes counts fast.
     Load More below reuses that same cache, so it never re-fetches.    */
  (function initLoadMore() {
    var btn = document.getElementById('cb-load-more');
    if (!grid) return;

    var pageCache = {}; // url -> { cards: [...detached nodes], next: url|null }

    function fetchPage(url) {
      if (pageCache[url]) return Promise.resolve(pageCache[url]);
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('coss-bundle-grid');
          var newBtn = doc.getElementById('cb-load-more');
          var page = {
            cards: newGrid ? Array.prototype.slice.call(newGrid.querySelectorAll('.coss-bundle-card')) : [],
            next: newBtn ? newBtn.dataset.next : null
          };
          pageCache[url] = page;
          return page;
        });
    }

    function tally(cards, into) {
      cards.forEach(function (card) {
        (card.dataset.cats ? card.dataset.cats.split(' ') : []).forEach(function (c) {
          if (c) into[c] = (into[c] || 0) + 1;
        });
      });
      return into;
    }

    function updateBadges(counts) {
      var filterBar = document.querySelector('.cb-filter-bar');
      if (!filterBar) return;
      filterBar.querySelectorAll('.cb-filter-btn[data-cat]').forEach(function (b) {
        if (b.dataset.cat === 'all') return;
        var span = b.querySelector('.cb-filter-count');
        if (span && counts[b.dataset.cat] != null) span.textContent = counts[b.dataset.cat];
      });
    }

    function syncCounts(url, counts) {
      fetchPage(url).then(function (page) {
        tally(page.cards, counts);
        updateBadges(counts);
        if (page.next) syncCounts(page.next, counts);
      });
    }

    if (!btn) return;

    var runningCounts = tally(Array.prototype.slice.call(grid.querySelectorAll('.coss-bundle-card')), {});
    updateBadges(runningCounts);
    syncCounts(btn.dataset.next, runningCounts);

    function insertNext(url) {
      return fetchPage(url).then(function (page) {
        page.cards.forEach(function (c) { grid.appendChild(c); });
        applyFilters(page.cards);
        if (page.next) return insertNext(page.next);
      });
    }

    var loadPromise = null;
    loadAllRemaining = function () {
      if (loadPromise) return loadPromise;
      btn.disabled = true;
      btn.textContent = 'Loading…';
      loadPromise = insertNext(btn.dataset.next)
        .then(function () { if (btn.parentNode) btn.parentNode.removeChild(btn); })
        .catch(function (err) {
          console.error('[coss-bundle] load more error:', err);
          btn.disabled = false;
          btn.textContent = 'Load More';
          loadPromise = null;
        });
      return loadPromise;
    };

    btn.addEventListener('click', loadAllRemaining);
  }());

  /* ── Sticky filter fallback ─────────────────────────────────────────────────
     #xo-root has overflow:hidden (fallback) which breaks CSS position:sticky on
     older browsers. IntersectionObserver runs always; the getBoundingClientRect
     check at callback time skips it when native sticky is already working.     */
  /* Sticky filter bar — scroll listener fires synchronously each frame so the
     bar locks to the header with zero perceptible delay (no IntersectionObserver
     batching lag). CSS sticky is left in place as a GPU-composited base; the
     scroll listener only applies the fixed fallback when CSS sticky is broken
     (overflow:hidden ancestors on older browsers / iOS Safari < 16).           */
  (function initStickyFilter() {
    var filterBar = document.querySelector('.cb-filter-bar');
    if (!filterBar) return;

    var topH = window.innerWidth >= 768 ? 63 : 50;

    var placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    filterBar.parentNode.insertBefore(placeholder, filterBar.nextSibling);

    var isFixed      = false;
    var barNatural   = -1; /* cached document-top offset of filter bar */
    var barLeft      = 0;
    var barWidth     = 0;

    function tick() {
      /* Cache position/size only while bar is in normal flow */
      if (!isFixed) {
        var rect   = filterBar.getBoundingClientRect();
        barNatural = rect.top + window.scrollY;
        barLeft    = rect.left;
        barWidth   = rect.width;
      }

      var shouldFix = window.scrollY + topH >= barNatural;
      if (shouldFix === isFixed) return;
      isFixed = shouldFix;

      if (isFixed) {
        placeholder.style.cssText = 'height:' + filterBar.offsetHeight + 'px;display:block';
        filterBar.classList.add('cb-filter-bar--fixed');
        filterBar.style.top   = topH + 'px';
        filterBar.style.left  = barLeft + 'px';
        filterBar.style.width = barWidth + 'px';
      } else {
        placeholder.style.cssText = 'display:none';
        filterBar.classList.remove('cb-filter-bar--fixed');
        filterBar.style.top   = '';
        filterBar.style.left  = '';
        filterBar.style.width = '';
      }
    }

    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }());

  /* Init */
  updateBar();

}());
